// 9fbef606107a605d69c0edbcd8029e5d
import { executeStatefulAPICall } from '../../../handler';
import endpoints from '../../../endpoints';

/**
 * @function chatGPTAPI - Used as abstract layer to do all server request and recieve the user query through AI Assistant.
 * @param {object} payload - data required to make server request.
 * @returns {object} success response or error response.
 */
const chatGPTAPI = ({payload}) => {
  const payloadAI = {
    webService: endpoints.chatGpt,
    body: {
      query: payload.query,
    }
  };
  return executeStatefulAPICall(payloadAI)
    .then((res) => {
      const { response } = res?.body || {};
      return response;
    })
    .catch((err) => {
      throw err;
    });
};

export default chatGPTAPI;
